import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { CareerSectionComponent } from './career-section.component';
import { CareerpageComponent } from './careerpage/careerpage.component';
import { CareerformComponent } from './careerform/careerform.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModuleModule } from '../material-module/material-module.module';

const routes:Routes=[
  { path: 'Careers', component: CareerpageComponent },
]

@NgModule({
  declarations: [ CareerpageComponent, CareerformComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    MaterialModuleModule,
    NgbNavModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ]
})
export class CareerModule { }
